import { LOCAL_STORE_JWT } from "~/utils/main";

const base = "//www.dreamchimney.com/api";

/**
 * Fetch one random track (with media). Optionally restrict to current user's tracks when onlyMyTracks is true.
 * POST /tracks/shuffle/random
 */
export function getShuffleRandomTrack(axios, options = {}) {
  const onlyMyTracks = options.onlyMyTracks === true;
  const body = { only_my_tracks: onlyMyTracks };
  if (onlyMyTracks) {
    body.jwt = localStorage.getItem(LOCAL_STORE_JWT) || "";
    if (options.chimdir) body.chimdir = options.chimdir;
  }
  return axios.post(`${base}/tracks/shuffle/random`, body).then((res) => res.data);
}
